const RemovedButton = ({ product, ...rest }) => null;
export default RemovedButton;
